import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "axios";

const CreateItem = () => {
  const [formData, setFormData] = useState({
    title: "",
    desc: "",
    price: "",
    category: [],
    availability: false,
    imageUrl: [],
  });
  //   const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleArrayChange = (e, field) => {
    setFormData({
      ...formData,
      [field]: e.target.value.split(",").map((item) => item.trim()),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("authToken");
      await axios.post(
        "https://ekhoni-khabo-server.vercel.app/api/v1/menu/create-item",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token to request headers
          },
        }
      );
      setFormData({
        title: "",
        desc: "",
        price: "",
        category: [],
        availability: false,
        imageUrl: [],
      });
      //   navigate("/items");
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Create New Item</h2>

        <div className="mb-4">
          <label className="block font-semibold mb-1">Title</label>
          <input
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="Enter item title"
            className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block font-semibold mb-1">Description</label>
          <input
            name="desc"
            value={formData.desc}
            onChange={handleChange}
            placeholder="Enter description"
            className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block font-semibold mb-1">Price</label>
          <input
            name="price"
            value={formData.price}
            onChange={handleChange}
            placeholder="Enter price"
            className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block font-semibold mb-1">Category</label>
          <input
            name="category"
            value={formData.category.join(",")}
            onChange={(e) => handleArrayChange(e, "category")}
            placeholder="Category (comma separated)"
            className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block font-semibold mb-1">Image URLs</label>
          <input
            name="imageUrl"
            value={formData.imageUrl.join(",")}
            onChange={(e) => handleArrayChange(e, "imageUrl")}
            placeholder="Image URLs (comma separated)"
            className="w-full p-2 border border-gray-300 rounded focus:ring focus:ring-green-300"
            required
          />
        </div>

        <div className="mb-4 flex items-center">
          <input
            type="checkbox"
            name="availability"
            checked={formData.availability}
            onChange={handleChange}
            className="mr-2"
          />
          <label className="font-semibold">Available</label>
        </div>

        <button
          type="submit"
          className="w-full bg-green-500 text-white p-3 rounded-lg font-bold hover:bg-green-600 transition"
        >
          Create Item
        </button>
      </form>
    </div>
  );
};

export default CreateItem;
